var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabsIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FE0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.8125V15.625C25 14.2989 24.4732 13.0271 23.5355 12.0895C22.5979 11.1518 21.3261 10.625 20 10.625C18.6739 10.625 17.4021 11.1518 16.4645 12.0895C15.5268 13.0271 15 14.2989 15 15.625V17.8125H13.4375V22.8125C13.4375 26.4311 16.3814 29.375 20 29.375C23.6186 29.375 26.5625 26.4311 26.5625 22.8125V17.8125H25ZM16.25 15.625C16.25 14.6304 16.6451 13.6766 17.3483 12.9733C18.0516 12.2701 19.0054 11.875 20 11.875C20.9946 11.875 21.9484 12.2701 22.6517 12.9733C23.3549 13.6766 23.75 14.6304 23.75 15.625V17.8125H16.25V15.625ZM25.3125 22.8125C25.3125 25.7418 22.9293 28.125 20 28.125C17.0707 28.125 14.6875 25.7418 14.6875 22.8125V19.0625H25.3125V22.8125Z",
    fill: "#FF3636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsIcon2);
export default __webpack_public_path__ + "static/media/tabs-icon2.52bf7c2587a89d9e42d1574f3196bbe0.svg";
export { ForwardRef as ReactComponent };